export const DRIVER_HEADERS = [
  "راننده‌",
  "شرکت‌",
  "کد ملی",
  "وضعیت",
  // "وضعیت مدارک",
  "تنظیمات",
];
export const Ticket_HEADERS = [
  "ردیف",
  "کاربر",
  "عنوان",
  "کد رهگیری",
  "وضعیت",
  "تاریخ ایجاد",
  "تاریخ آپدیت",
  "عملیات",
];
export const ORDER_HEADERS = ["مشتری", "شهر", "توضیحات", "آدرس", "وضعیت", ""];
export const ORDER_INFO_HEADERS = ["دسته بندی", "وزن", "قیمت واحد", "قیمت کل"];
export const CLIENT_HEADERS = ["نام و نام خانوادگی", "آدرس", "وضعیت", ""];
export const CATEGORY_PRICE_HEADERS = ["نام دسته بندی", "قیمت", "ویرایش"];
export const MUNICIPALITY_HEADERS = ["نام شهرداری", "استان", "شهر", ""];
export const COMPANY_HEADERS = [
  "نام شرکت",
  "نام پیمانکار",
  "شهر",
  "وضعیت",
  "تنظیمات",
];
export const ADMIN_HEADERS = [
  "نام و نام خانوادگی",
  "شماره موبایل",
  "",
  "عملیات",
];
export const TRANSACTION_TABLE_HEADER = [
  "ردیف",
  "نوع تراکنش",
  "پرداخت / واریز کننده ",
  "دانش آموز",
  "هزینه",
  "تاریخ تراکنش",
  "بابت",
  "تعداد فاکتور",
  "درگاه پرداخت ",
  "شناسه پرداخت ",
  "شرکت ",
  "شهر ",
  "وضعیت تراکنش ",
  "گزینه ها ",
];
